import { defineFcm } from '../shared/factory';

export const FCM_CORGI_SSR_TIMINGS_RESPONSE_HEADER = defineFcm('corgi_ssr_timings_response_header')
	.asBoolean()
	.withDefault(false)
	.toConfig();
